// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"0b2c0dc8","642":"31bcd800","862":"3e245dca","919":"dba22d09"}[chunkId] + ".chunk.js";
};